import { Component, OnInit } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {LetterSubscriberService} from 'src/app/services/letter-subscriber.service';

@Component({
  selector: 'app-letters-subscribers-back',
  templateUrl: './letters-subscribers-back.component.html',
  styleUrls: ['./letters-subscribers-back.component.scss']
})
export class LettersSubscribersBackComponent implements OnInit {

  public param: any;
  public emailId: any;
  public emailData: any;

  public flagDone: boolean = false;

  constructor(
     private route: ActivatedRoute,
         private _letterSubscriberService: LetterSubscriberService,
  ) { 
    this.param = this.route.snapshot.paramMap.get('token');

    this._letterSubscriberService.getSentById(this.param)
    .subscribe((result)=>{
      this.emailId = result.id;
      this.emailData = result.data();
    })


  }

  ngOnInit() {
  }

  updateAccept(flag : any){
    this._letterSubscriberService.updateSent(this.param, flag)
    .then(()=>{
      this.flagDone = true;
    })
    .catch((err: any)=>{
      console.log(err.message);
    })
  }

}
